module.exports = __webpack_public_path__ + "img/nova_poshta.ba0b9785.png";